function getCurrentPageFromURL() {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get('page'), 10);
  return isNaN(page) || page < 1 ? 1 : page;
}
document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll('facet-filters-form input');

  inputs.forEach(input => {
    input.addEventListener("keypress", function (event) {
      if (event.key === "Enter") {
        event.preventDefault(); // Stop form submission
      }
    });
  });
});
function toggleClassByViewPreferences() {
  if( document.querySelector('[name="itemsview"]:checked') ){
    var view = document.querySelector('[name="itemsview"]:checked').value;
    if( view == 'list' ){
      document.querySelector('.product-grid-container').classList.add('product-list-view');
    }else{
      document.querySelector('.product-grid-container').classList.remove('product-list-view');
    }
  }
}
function updateProductRange() {
  
  const itemsPerPageInput = document.querySelector('input[name="itemsperpage"]');
  const startSpan = document.querySelector('.start_count');
  const endSpan = document.querySelector('.end_count');
  const totalSpan = document.querySelector('.total');
  const currentPageInput = getCurrentPageFromURL();
  
  const perPage = parseInt(itemsPerPageInput.value, 10);
  const currentPage = parseInt(currentPageInput.value, 10);
  const total = parseInt(document.querySelector('#ProductCount .total')?.textContent.trim(), 10);

  const start = (perPage * (currentPage - 1)) + 1;
  let end = perPage * currentPage;
  if (end > total) end = total;

  startSpan.textContent = start;
  endSpan.textContent = end;
  totalSpan.textContent = total;
}


/**
 * Update Items per page value in cart attributes.
 */
document.addEventListener('DOMContentLoaded', function () {
  toggleClassByViewPreferences();
  const Element = document.querySelector('[name="itemsperpage"]');
  const Element2 = document.querySelectorAll('[name="itemsview"]');

  function updateCartAttribute(attributeName, value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          [attributeName]: value
        }
      })
    });
  }

  function handleInputChange(event) {
    const selectedValue = event.target.value;
    updateCartAttribute('itemsPerPage', selectedValue);
  }

  function handleElement2Change(event) {
    const selectedValue = event.target.value;
    updateCartAttribute('itemsView', selectedValue);
  }

  if (Element) {
    ['change', 'keyup', 'keydown'].forEach(eventType => {
      Element.addEventListener(eventType, handleInputChange);
    });
  }

  if (Element2.length) {
    Element2.forEach(el => {
      ['change', 'keyup', 'keydown'].forEach(eventType => {
        el.addEventListener(eventType, handleElement2Change);
      });
    });
  }
});


jQuery(document).ready(function ($) {
  // FAQ Accordion JS Start
  jQuery(".faq-accordion .faq-accordion-content").hide();
  
  jQuery(".faq-accordion-title").click(function (j) {
      var $this = jQuery(this);
      var dropDown = $this.closest(".faq-accordion-box").find(".faq-accordion-content");
      var accordion = $this.closest(".faq-accordion");
  
      accordion.find(".faq-accordion-content").not(dropDown).slideUp();
  
      if ($this.hasClass("active-faq")) {
          $this.removeClass("active-faq");
      } else {
          accordion.find(".faq-accordion-title.active-faq").removeClass("active-faq");
          $this.addClass("active-faq");
      }
  
      dropDown.stop(false, true).slideToggle({
          duration: 300,
          complete: function () {
              // Scroll to the top of the accordion box
              jQuery('html, body').animate({
                  scrollTop: $this.closest(".faq-accordion-box").offset().top - 130
              }, 400);
          }
      });
  
      j.preventDefault();
  });
  // FAQ Accordion JS End
});